// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/Cards/VirusCard/VirusCard.css
// module id = 961
// module chunks = 0